module.exports = __webpack_public_path__ + "static/media/Section-1.a204ca78.mp3";